<template>
    <div data-testid="experience-levels-filter">
        <h3>{{ $t('search.filters.experience.level') }}</h3>
        <div v-for="experienceLevel in availableSearchFilters?.experienceLevels" :key="experienceLevel.key">
            <VJoyCheckbox
                :checked="isChecked(experienceLevel.key)"
                :data-testid="`experience-levels-filter-${experienceLevel.key}`"
                @update:checked="toggleFilter(experienceLevel.key)"
            >
                {{ experienceLevel.label }} ({{ experienceLevel.count }})
            </VJoyCheckbox>
        </div>
    </div>
</template>

<script setup lang="ts">
    import {storeToRefs} from 'pinia';
    import {VJoyCheckbox} from '@maltjoy/core-vue';
    import {RetrieveAvailableFiltersExpEnum} from '@api';
    import {useFiltersStore} from '../stores/filters.store';

    const filtersStore = useFiltersStore();
    const {availableSearchFilters} = storeToRefs(filtersStore);

    function isExperienceLevel(experienceLevel: string): experienceLevel is RetrieveAvailableFiltersExpEnum {
        return Object.values(RetrieveAvailableFiltersExpEnum).some((level) => level === experienceLevel);
    }

    function isChecked(experienceLevel: string) {
        if (!isExperienceLevel(experienceLevel)) {
            return false;
        }

        return filtersStore.isExperienceLevelChecked(experienceLevel);
    }

    function toggleFilter(experienceLevel: string) {
        if (!isExperienceLevel(experienceLevel)) {
            return;
        }

        filtersStore.toggleExperienceLevel(experienceLevel);
    }
</script>
